import { callLengthText, formatDateTime, formatPhone, t, type DateFormat, type RecentCallRow } from '@bms2/shared';
import { Modal } from '../../components/modals/Modal';
import { PlayLink } from './PlayLink';
import styles from './CallList.module.css';

export interface CallWindowProps {
  row: RecentCallRow & { recordName: string | null };
  zone: string;
  dateFormat: DateFormat;
  onClose: () => void;
}

/**
 * 🔒 The call's own window (decision 11860), for a call that wrote no note: the two numbers, the start and end times in
 * the viewer's zone, the length, the matched record, Play where a recording exists, and the transcript.
 */
export function CallWindow({ row, zone, dateFormat, onClose }: CallWindowProps) {
  const facts: [string, string][] = [
    [t('phonePages.window.from'), formatPhone(row.fromNumber) || t('phonePages.unknownCaller')],
    [t('phonePages.window.to'), formatPhone(row.toNumber)],
    [t('phonePages.window.started'), formatDateTime(row.at, zone, dateFormat)],
    ...(row.endedAt ? [[t('phonePages.window.ended'), formatDateTime(row.endedAt, zone, dateFormat)] as [string, string]] : []),
    ...(callLengthText(row.durationSeconds) ? [[t('phonePages.window.length'), callLengthText(row.durationSeconds)] as [string, string]] : []),
    ...(row.recordName ? [[t('phonePages.window.record'), row.recordName] as [string, string]] : []),
  ];
  return (
    <Modal open title={t('phonePages.window.title')} dataModal="call-window" onCancel={onClose} actions={[{ kind: 'close', label: t('phonePages.window.close'), onAct: onClose }]}>
      <div className={styles.window} data-call-window={row.id}>
        <dl className={styles.facts}>
          {facts.map(([label, value]) => (
            <div key={label} className={styles.fact}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
        {row.recordingUrl ? <PlayLink url={row.recordingUrl} /> : null}
        {row.transcript ? (
          <section className={styles.transcript} aria-label={t('phonePages.window.transcript')}>
            <h3 className={styles.heading}>{t('phonePages.window.transcript')}</h3>
            <p className={styles.transcriptText}>{row.transcript}</p>
          </section>
        ) : null}
      </div>
    </Modal>
  );
}
